import * as service from './activitylist.service'
export default {
  data() {
    var checkPools = (rule, value, callback) => {
      if (value.length > 0) {
        callback()
      } else {
        return callback(new Error('This field is required'))
      }

    }
    var checkfuturedate = (rule, value, callback) => {

      var diffDays = "";
      this.WeekDays = this.SetWeekDays();
      if (value) {

        if (this.addActivities.StartDate && this.addActivities.EndDate) {
          if (this.addActivities.EndDate < this.addActivities.StartDate) {
            this.showProgramShedule = false;
            return callback(new Error('End Date should be after the Start Date'))

          } else {
            this.showProgramShedule = true;
            var dateStart = new Date(this.addActivities.StartDate);
            var dateEnd = new Date(this.addActivities.EndDate);
            var timeDiff = Math.abs(dateEnd.getTime() - dateStart.getTime());
            diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

            if (diffDays > 7 || diffDays == 7) {
              this.FullWeek = true;

              this.WeekDays = this.SetWeekDays();

              for (var i = 0; i < this.WeekDays.length; i++) {

                this.WeekDays[i].Status = false;

              }
              callback()
            } else {
              this.FullWeek = false;

              //calculate the weeks
              var text = "";
              var Startdate = new Date(this.addActivities.StartDate);
              var start = new Date(this.addActivities.StartDate);
              var Enddate = new Date(this.addActivities.EndDate);


              let context = this;

              Date.prototype.addDays = function (days) {
                var date = new Date(this.valueOf())
                date.setDate(date.getDate() + days);
                return date;
              }

              function getDates(startDate, stopDate) {
                var dateArray = new Array();
                var currentDate = startDate;
                while (currentDate <= stopDate) {
                  var datee = new Date(currentDate);
                  datee = context.$moment(datee).format('dddd')
                  dateArray.push(datee);

                  for (var z = 0; z < context.WeekDays.length; z++) {
                    if (context.WeekDays[z].Name == datee) {
                      context.WeekDays[z].Status = false;
                    }
                  }
                  currentDate = currentDate.addDays(1);
                }
                return dateArray;
              }

              var Dates = getDates(Startdate, Enddate)
              callback()

            }
          }
        } else {
          this.showProgramShedule = false;
          callback()
        }

      } else {
        this.showProgramShedule = false;
        return callback(new Error('Please pick a date'))
      }
    }


    var checktime = (rule, value, callback) => {



      switch (rule.field) {
        case "SaturdayEnd":
          if (this.addActivities["SaturdayStart"]) {
            if (this.addActivities["SaturdayEnd"] < this.addActivities["SaturdayStart"]) {
              return callback(new Error('End Date should be after the Start Date'))
            } else {
              callback()
            }
          } else {
            callback()
          }

          break;

        case "SundayEnd":
          if (this.addActivities["SundayStart"]) {
            if (this.addActivities["SundayEnd"] < this.addActivities["SundayStart"]) {
              return callback(new Error('End Date should be after the Start Date'))
            } else {
              callback()
            }
          } else {
            callback()
          }

          break;


        case "MondayEnd":
          if (this.addActivities["MondayStart"]) {
            if (this.addActivities["MondayEnd"] < this.addActivities["MondayStart"]) {
              return callback(new Error('End time should be greater than Start time'))
            } else {
              callback()
            }
          } else {
            callback()
          }

          break;

        case "TuesdayEnd":
          if (this.addActivities["TuesdayStart"]) {
            if (this.addActivities["TuesdayEnd"] < this.addActivities["TuesdayStart"]) {
              return callback(new Error('End time should be greater than Start time'))
            } else {
              callback()
            }
          } else {
            callback()
          }

          break;
        case "WednesdayEnd":
          if (this.addActivities["WednesdayStart"]) {
            if (this.addActivities["WednesdayEnd"] < this.addActivities["WednesdayStart"]) {
              return callback(new Error('End time should be greater than Start time'))
            } else {
              callback()
            }
          } else {
            callback()
          }

          break;
        case "ThursdayEnd":
          if (this.addActivities["ThursdayStart"]) {
            if (this.addActivities["ThursdayEnd"] < this.addActivities["ThursdayStart"]) {
              return callback(new Error('End time should be greater than Start time'))
            } else {
              callback()
            }
          } else {
            callback()
          }

          break;
        case "FridayEnd":
          if (this.addActivities["FridayStart"]) {
            if (this.addActivities["FridayEnd"] < this.addActivities["FridayStart"]) {
              return callback(new Error('End time should be greater than Start time'))
            } else {
              callback()
            }
          } else {
            callback()
          }

          break;
      }


    };
    return {

      Activities: [],
      WeekDays: [],
      FullWeek: false,
      // value2: new Date(2016, 9, 10, 18, 40),
      showProgramShedule: false,
      ShowActivityList: true,
      ActivityCoulmns: ['StartDate', 'EndDate', 'ActivityTypeDesc', 'ProgramName', 'LocationName', 'PoolNames', 'AddedBy', 'Actions'],
      optionstable: {
        headings: {
          StartDate: 'Start Date',
          EndDate: 'End Date',
          ActivityTypeDesc: 'Type',
          ProgramName: 'Activity',
          LocationName: 'Aquatic Facility',
          PoolNames: 'Aquatic Venue',
          AddedBy: 'Entered By',
          Actions: ''
        },
        sortIcon: {
          base: 'glyphicon',
          up: 'glyphicon-chevron-up',
          down: 'glyphicon-chevron-down'
        },
        perPage: 10,
        perPageValues: [5, 10, 25, 50, 100],
        sortable: ['Description', 'CommentedBy', 'ActionTypeName', 'ActionDate'],
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },
      emittedlocationid: '',
      pools: [],
      EditID: '',
      Locations: [],
      ActivityTypes: [],
      labelPosition: 'top',
      LocationID: '',
      currenTab: '',
      locationName: '',
      addActivities: {

        "LocationId": "",
        "PoolIds": [],
        "Organizer": "",
        "StartDate": "",
        "EndDate": "",
        "Description": "",
        "PoolLane": "",
        "PoolZone": "",
        "Notes": "",
        "Capacity": "",
        "TargetRevenue": "",
        "TargetExpense": "",
        "TargetProfit": "",
        "MondayStart": "",
        "MondayEnd": "",
        "TuesdayStart": "",
        "TuesdayEnd": "",
        "WednesdayStart": "",
        "WednesdayEnd": "",
        "ThursdayStart": "",
        "ThursdayEnd": "",
        "FridayStart": "",
        "FridayEnd": "",
        "SaturdayStart": "",
        "SaturdayEnd": "",
        "SundayStart": "",
        "SundayEnd": "",
        "Id": "",

        "ProgramName": "",
        "ActivityTypeId": "",
        "ActivityTypeDesc": ""
      },

      rules: {

        ActivityTypeId: [{
          required: true,
          message: 'This field is required',
          trigger: 'change',
          type: 'number'
        }, ],
        PoolIds: [{
          required: true,
          message: 'This field is required',
          trigger: 'change',
          validator: checkPools
        }, ],
        LocationId: [{
          required: true,
          message: 'This field is required',
          trigger: 'change',
          type: 'number'
        }, ],
        StartDate: [{
          type: 'date',
          required: true,
          trigger: 'change',
          validator: checkfuturedate,
        }],
        EndDate: [{
          type: 'date',
          required: true,
          trigger: 'change',
          validator: checkfuturedate,
        }],

        ProgramName: [{
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 100,
            message: 'Length should be 1 to 100'
          }
        ],

        PoolLane: [

          {
            min: 1,
            max: 100,
            message: 'Length should be 1 to 100'
          }
        ],

        PoolZone: [

          {
            min: 1,
            max: 100,
            message: 'Length should be 1 to 100'
          }
        ],


        Notes: [

          {
            min: 1,
            max: 500,
            message: 'Length should be 1 to 500'
          }
        ],

        Description: [

          {
            min: 1,
            max: 250,
            message: 'Length should be 1 to 250'
          }
        ],

        Organizer: [

          {
            min: 1,
            max: 100,
            message: 'Length should be 1 to 100'
          }
        ],


        SaturdayEnd: [{
          trigger: 'blur',
          validator: checktime
        }],
        SundayEnd: [{
          trigger: 'blur',
          validator: checktime
        }],
        MondayEnd: [{
          trigger: 'blur',
          validator: checktime
        }],
        TuesdayEnd: [{
          trigger: 'blur',
          validator: checktime
        }],
        WednesdayEnd: [{
          trigger: 'blur',
          validator: checktime
        }],
        ThursdayEnd: [{
          trigger: 'blur',
          validator: checktime
        }],
        FridayEnd: [{
          trigger: 'blur',
          validator: checktime
        }],


      },
    }
  },
  mounted() {

    let context = this
    $('#calView').hide();
    this.btn = "Save"
    this.isAddingOrEditing = ""
    this.GetLocations();
    this.WeekDays = this.SetWeekDays();



    this.$router.app.$on('emittedlocation_obj', (data) => {
      context.LocationID = data.LocationId ? data.LocationId : ''
      context.locationName = data.LocationName ? ' - ' + data.LocationName : ''
      if (context.LocationID) {
        this.GetAllActivity(context.LocationID);
      }

    })
    this.GetAllActivityTypes();
  },

  methods: {


    handleClick(ev) {
      this.currenTab = ev.label
      if (this.currenTab == 'Activity Calendar') {
        $('#calView').show()
      } else {
        $('#calView').hide()
      }


    },
    ShowAddActivities() {
      this.ShowActivityList = false
      this.btn = "Save"
      this.isAddingOrEditing = "A"
      let context = this;

      this.addActivities = {

        "LocationId": "",
        "PoolIds": [],
        "Organizer": "",
        "StartDate": "",
        "EndDate": "",
        "Description": "",
        "PoolLane": "",
        "PoolZone": "",
        "Notes": "",
        "Capacity": "",
        "TargetRevenue": "",
        "TargetExpense": "",
        "TargetProfit": "",
        "MondayStart": "",
        "MondayEnd": "",
        "TuesdayStart": "",
        "TuesdayEnd": "",
        "WednesdayStart": "",
        "WednesdayEnd": "",
        "ThursdayStart": "",
        "ThursdayEnd": "",
        "FridayStart": "",
        "FridayEnd": "",
        "SaturdayStart": "",
        "SaturdayEnd": "",
        "SundayStart": "",
        "SundayEnd": "",
        "Id": "",
        "ProgramName": "",
        "ActivityTypeId": "",
        "ActivityTypeDesc": ""
      }
      this.WeekDays = this.SetWeekDays();
    },

    GetAllActivity(locationid) {
      let context = this
      loader.startLoader()
      service.GetAllActivity(locationid).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
          context.Activities = []
          loader.stopLoader()
          return;
        }

        loader.stopLoader()

        if (response) {
          context.Activities = response
          context.$refs.dragtable.setPage(1)
          for (var i = 0; i < response.length; i++) {
            context.Activities[i].AddedOn = (context.Activities[i].AddedOn) ? context.$options.filters.fdate(context.Activities[i].AddedOn) : '';
            context.Activities[i].EndDate = (context.Activities[i].EndDate) ? context.$options.filters.fdate(context.Activities[i].EndDate) : '';
            context.Activities[i].StartDate = (context.Activities[i].StartDate) ? context.$options.filters.fdate(context.Activities[i].StartDate) : '';
          }
          tooltip.startTooltip(50)
        } else {
          context.Activities = []
        }


      }, (error) => {

        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })

    },
    cancel() {
      this.isAddingOrEditing = ""
      this.ShowActivityList = true;
    },
    getpools(locationid) {
      let context = this;
      service.GetPools(locationid).then(function (response) {

        if (response) {
          if (response.length > 0) {
            context.pools = response
          }
        }
      }, (error) => {

      })
    },
    GetLocations() {
      let context = this;
      service.GetLocations().then(function (response) {
        context.Locations = response;
      }, (error) => {

      })
    },


    GetAllActivityTypes() {

      let context = this;
      service.GetAllActivityTypes().then(function (response) {

        if (response) {
          if (response.length > 0) {
            context.ActivityTypes = response
          }
        }
      }, (error) => {

      })
    },

    SetWeekDays() {
      return [{
          Name: "Monday",
          Status: true
        },
        {
          Name: "Tuesday",
          Status: true
        },
        {
          Name: "Wednesday",
          Status: true
        },
        {
          Name: "Thursday",
          Status: true
        },
        {
          Name: "Friday",
          Status: true
        },
        {
          Name: "Saturday",
          Status: true
        }, {
          Name: "Sunday",
          Status: true
        },
      ]
    },
    submitForm(formName) {

      this.$refs[formName].validate((valid) => {

        if (valid) {
          let context = this
          loader.startLoader()
          context.addActivities["Id"] = 0;
          context.addActivities['StartDate'] = context.$moment(context.addActivities['StartDate']).format('MM-DD-YYYY')
          context.addActivities['EndDate'] = context.$moment(context.addActivities['EndDate']).format('MM-DD-YYYY')


          service.AddActivity(context.addActivities).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
              loader.stopLoader()
              return;
            }

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Succesfully Created Activity',
              type: 'success'
            })

            context.GetAllActivity(context.LocationID);
            context.ShowActivityList = true
            context.$router.app.$emit('emitCalender', 'test')
          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'ACTIVITY - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    //FG - FOOF - After Cert - First Release (6) - rewrote delete code below to use new methods in hydrowareCommonJS.js
    //The delete function below deletes a row from the table
    del: function (data) {
      var ID = data.row.Id
      let context = this
      var opts = {message: 'Are you sure you want to delete ' + data.row.ProgramName + '?'}
      context.$hydrowareCommonJS.displayConfirmDeletePopup(context, opts, context.deleteActivityRow.bind(null,ID))
    },
    deleteActivityRow(ID) {
      var context = this;
      loader.startLoader()
      service.DeleteActivity(ID).then(function (response) {

        //Is this restricted ? -- FG - After Cert - First Release Security
        if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
          loader.stopLoader()
          return;
        }

        context.GetAllActivity(context.LocationID);
        context.$router.app.$emit('emitCalender', 'test')
        context.ShowActivityList = true
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyDeleteSuccess(context);
      },
      (error) => {
        loader.stopLoader()
        context.$hydrowareCommonJS.notifyError(context,{message: error.responseJSON.Message})
      })
    },


    locationchanged(id) {

      this.getpools(id)
      this.addActivities.PoolIds = [];
    },

    Update: function (formName) {


      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context = this
          loader.startLoader()

          context.addActivities["Id"] = context.EditID;
          context.addActivities['StartDate'] = context.$moment(context.addActivities['StartDate']).format('MM-DD-YYYY')
          context.addActivities['EndDate'] = context.$moment(context.addActivities['EndDate']).format('MM-DD-YYYY')

          service.UpdateActivity(context.addActivities).then(function (response) {

            //Is this restricted ? -- FG - After Cert - First Release Security
            if(context.$hydrowareCommonJS.displayHydrowareRestrictedMessageIfApplicable(response,context,{})) {                 
              loader.stopLoader()
              return;
            }

            loader.stopLoader()
            context.$router.app.$emit('emitCalender', 'test')
            context.$notify({
              title: 'Success',
              message: 'Succesfully Updated Activities',
              type: 'success'
            })

            context.GetAllActivity(context.LocationID);
            context.ShowActivityList = true
          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })

        } else {
          this.$notify({

            title: 'Error',

            message: 'ACTIVITY - 2error while submit!!',

            type: 'error'

          })
          return false
        }


      })


    },

    editcol: function (data) {

      var ID = data.row.Id
      this.EditID = ID;
      let context = this;

      service.GetActivityDetails(ID).then(function (response) {
        context.addActivities = response
        context.ShowActivityList = false
        context.btn = "Update"
        context.isAddingOrEditing = "E"
        var diffDays;

        context.getpools(context.addActivities.LocationId)
        context.showProgramShedule = true;
        // context.WeekDays=context.SetWeekDays();

        context.showProgramShedule = true;
        var dateStart = new Date(context.addActivities.StartDate);
        var dateEnd = new Date(context.addActivities.EndDate);
        var timeDiff = Math.abs(dateEnd.getTime() - dateStart.getTime());
        diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

        if (diffDays > 7 || diffDays == 7) {
          context.FullWeek = true;

          context.WeekDays = context.SetWeekDays();

          for (var i = 0; i < context.WeekDays.length; i++) {

            context.WeekDays[i].Status = false;

          }
        } else {
          // let context=this;
          context.FullWeek = false;

          var text = "";

          Date.prototype.addDays = function (days) {
            var date = new Date(this.valueOf())
            date.setDate(date.getDate() + days);
            return date;
          }

          while (dateStart <= dateEnd) {

            var datee = new Date(dateStart);
            datee = context.$moment(datee).format('dddd')


            for (var z = 0; z < context.WeekDays.length; z++) {
              if (context.WeekDays[z].Name == datee) {
                context.WeekDays[z].Status = false;
              }
            }
            dateStart = dateStart.addDays(1);
          }


        }

      }, (error) => {
        this.$notify({

          title: 'Error',

          message: error,

          type: 'error'

        })
      })

    },


    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {
    "addActivities.StartDate": function (val) {
      if (!val) {

        this.showProgramShedule = false;
      }
    },
    "addActivities.EndDate": function (val) {
      if (!val) {

        this.showProgramShedule = false;
      }
    },
    "addActivities.LocationId": function (val) {
      // this.addActivities.PoolIds=[];
      this.getpools(val);
    },
    WeekDays: function (val) {

      for (var a = 0; a < val.length; a++) {

        this.addActivities.MondayStart = (val[a].Name == "Monday" && val[a].Status) ? "" : this.addActivities.MondayStart;
        this.addActivities.MondayEnd = (val[a].Name == "Monday" && val[a].Status) ? "" : this.addActivities.MondayEnd;

        this.addActivities.TuesdayStart = (val[a].Name == "Tuesday" && val[a].Status) ? "" : this.addActivities.TuesdayStart;
        this.addActivities.TuesdayEnd = (val[a].Name == "Tuesday" && val[a].Status) ? "" : this.addActivities.TuesdayEnd;

        this.addActivities.WednesdayStart = (val[a].Name == "Wednesday" && val[a].Status) ? "" : this.addActivities.WednesdayStart;
        this.addActivities.WednesdayEnd = (val[a].Name == "Wednesday" && val[a].Status) ? "" : this.addActivities.WednesdayEnd;

        this.addActivities.ThursdayStart = (val[a].Name == "Thursday" && val[a].Status) ? "" : this.addActivities.ThursdayStart;
        this.addActivities.ThursdayEnd = (val[a].Name == "Thursday" && val[a].Status) ? "" : this.addActivities.ThursdayEnd;

        this.addActivities.FridayStart = (val[a].Name == "Friday" && val[a].Status) ? "" : this.addActivities.FridayStart;
        this.addActivities.FridayEnd = (val[a].Name == "Friday" && val[a].Status) ? "" : this.addActivities.FridayEnd;

        this.addActivities.SaturdayStart = (val[a].Name == "Saturday" && val[a].Status) ? "" : this.addActivities.SaturdayStart;
        this.addActivities.SaturdayEnd = (val[a].Name == "Saturday" && val[a].Status) ? "" : this.addActivities.SaturdayEnd;

        this.addActivities.SundayStart = (val[a].Name == "Sunday" && val[a].Status) ? "" : this.addActivities.SundayStart;
        this.addActivities.SundayEnd = (val[a].Name == "Sunday" && val[a].Status) ? "" : this.addActivities.SundayEnd;

      }
    }
  },
  watch: {
    "addActivities.Capacity": function (val) {
      let context = this
      setTimeout(function () {

        context.addActivities.Capacity = context.addActivities.Capacity.replace(/[^0-9.]/g, "");
      }, 100)


    },
    "addActivities.TargetRevenue": function (val) {
      let context = this
      setTimeout(function () {

        context.addActivities.TargetRevenue = context.addActivities.TargetRevenue.replace(/[^0-9.]/g, "");
      }, 100)


    },
    "addActivities.TargetExpense": function (val) {
      let context = this
      setTimeout(function () {

        context.addActivities.TargetExpense = context.addActivities.TargetExpense.replace(/[^0-9.]/g, "");
      }, 100)


    },
    "addActivities.TargetProfit": function (val) {
      let context = this
      setTimeout(function () {

        context.addActivities.TargetProfit = context.addActivities.TargetProfit.replace(/[^0-9.]/g, "");
      }, 100)


    },
    ShowActivityList: function (val) {
      this.$router.app.$emit('sidebar_hide', !val)
    }


  },

}



// WEBPACK FOOTER //
// ./src/pages/activitylist/activitylist.controller.js